import { SearchableSelect } from 'components/core';
import { FieldDef } from 'helpers/kpiBuilder/types';
import { TextBox } from './TextBox';

interface FieldPickerProps {
  /** Suggested fields for the chosen data. Any other field can still be typed. */
  fields: FieldDef[];
  value: string;
  placeholder: string;
  onChange: (field: string) => void;
}

const textOf = (f: FieldDef): string => `${f.label} (${f.field})`;

// Pick a known field from the list, or type any field name.
export const FieldPicker = ({ fields, value, placeholder, onChange }: FieldPickerProps) => {
  const known = fields.find((f) => f.field === value);
  return (
    <div className="row g-2">
      {fields.length > 0 && (
        <div className="col-md-6">
          <SearchableSelect options={fields.map(textOf)} selected={known ? textOf(known) : ''} placeholder="Choose a known field" onChange={(t) => onChange(fields.find((f) => textOf(f) === t)?.field ?? value)} />
        </div>
      )}
      <div className={fields.length > 0 ? 'col-md-6' : 'col-12'}>
        <TextBox value={value} placeholder={placeholder} onChange={onChange} />
      </div>
    </div>
  );
};
